import React, { forwardRef, useEffect, useRef } from 'react'
import SectionTitle from './SectionTitle';

const EahsForm = forwardRef(({ children, title = "", ish3 = false, style = {}, className = "", isNoMargin = false, isSectionTitle = false, isform = false, ...props }, ref) => {
    const followUpRef = useRef(null);

    useEffect(() => {
        if (followUpRef.current) {

            followUpRef.current.scrollTop = followUpRef.current.scrollHeight + 20;
        }
    }, [])

    return (
        <>
            {!!title && !isSectionTitle &&
                <div className={`col-lg-12 col-md-12 col-sm-12 ${isNoMargin ? " " : "mt-3"}  fw-bold text-start horseCardTitle mb-form-group`}  >
                    {title}
                </div>
            }
            {!!title && isSectionTitle &&
                <SectionTitle ish3={ish3} noMargin isContainer={false} section_name={title} />
            }
            {isform ?
                <form
                    className={`p-main bg-white border-15 p-3 ${className}`}
                    style={style}
                    {...props}
                    ref={followUpRef}
                >
                    <div className={`row rtl ${isNoMargin ? 'mx-0' : ''}`}>
                        {children}
                    </div>
                </form>
                :
                <div
                    className={` ${className}`}
                    style={style}
                    ref={followUpRef}
                >
                    <div className='p-main bg-white border-15 p-3'>
                        <div className={`row rtl ${isNoMargin ? 'mx-0' : ''}`}>
                            {children}
                        </div>
                    </div>
                </div>
            }
        </>
    )
})

export default EahsForm